<template>
  <div class="addIframeWidth">
    <iframe id="iframe" :src="srcUrl" frameborder="0"></iframe>
  </div>
</template>

<script>
import store from "@/store";
export default {
  data() {
    return {
      srcUrl: "",
      originUrl: "",
    };
  },
  mounted() {
    let { url } = this.$route.params;
    if (this.$route.query.outUrl) {
      const { modules, outUrl, webSiteUrl } = this.$route.query;
      if (this.$phoneSize()) {
        if (modules == "live") {
          url = `${webSiteUrl}/sub_activities/pages/live/live?id=${outUrl}`;
        } else {
          url = `${webSiteUrl}/sub_activities/pages/iframeDetail/iframeDetail?id=${outUrl}`;
        }
      } else {
        if (modules == "live") {
          url = `${webSiteUrl}/lives/${outUrl}`;
        } else {
          url = `${webSiteUrl}/activities/${outUrl}`;
        }
      }
    } else {
      if (url) {
        localStorage.setItem("iframeUrl", url);
      } else {
        if (this.$route.query && this.$route.query.url) {
          url = this.$route.query.url;
        } else {
          url = localStorage.getItem("iframeUrl");
        }
      }
    }
    this.originUrl = url;

    console.log("url", url);
    const vuexInfo = JSON.parse(localStorage.getItem("vuex"));
    const phone = vuexInfo?.user?.userVip
      ? vuexInfo.user.userInfo.cellphone
      : vuexInfo.user.noVipPhone;

    if (url && url.indexOf("?") !== -1) {
      this.srcUrl = `${url}&token=${
        store.state.user.token
      }&source=newgrand&phone=${phone}&timestamp=${new Date().getTime()}`;
      console.log("this.srcUrl1", this.srcUrl);
    } else {
      this.srcUrl = `${url}?token=${
        store.state.user.token
      }&source=newgrand&phone=${phone}&timestamp=${new Date().getTime()}`;
      console.log("this.srcUrl2", this.srcUrl);
    }
    window.addEventListener("message", this.handleIframeMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleIframeMessage);
    const iframe = document.getElementById("iframe");
    iframe.src = ""; // 清空iframe的src或者重新加载一个空页面
  },
  methods: {
    handleIframeMessage(event) {
      console.log("你的iframe页面源", event);
      // console.log("你的iframe页面源originUrl", this.originUrl);
      // if (event.data && event.data.message) {
      //   const iframe = document.getElementById("iframe");
      //   if (iframe) {
      //     iframe.style.height = parseInt(event.data.message) + 50 + "px";
      //   }
      // }
      if (this.originUrl.indexOf(event.origin) !== -1) {
        // 确保消息来自可信的源
        console.log("Received message from iframe:", event.data);
        // 这里可以处理消息...
        if (event.data && event.data.message) {
          const iframe = document.getElementById("iframe");
          if (iframe) {
            iframe.style.height = parseInt(event.data.message) + 50 + "px";
          }
        }
      }
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 500px) {
  .addIframeWidth {
    width: 100%;
    margin: 20px auto;
  }
  iframe {
    width: 100%;
    min-height: 100vh;
    /* Adjust the 100px to the height of the top navigation */
    /* position: absolute; */
    /* top: 100px; */
    /* Adjust this value to match the height of the top navigation */
    /* left: 0; */
    border: none;
  }
}
@media screen and (min-width: 501px) {
  .addIframeWidth {
    width: 1230px;
    margin: 20px auto;
  }
  iframe {
    width: 100%;
    overflow-x: hidden;
    min-height: calc(100vh - 260px);
    /* Adjust the 100px to the height of the top navigation */
    /* position: absolute; */
    /* top: 100px; */
    /* Adjust this value to match the height of the top navigation */
    /* left: 0; */
    border: none;
  }
}
</style>
